import React, { useRef } from 'react';
import pcModule from './Square.pc.module.css';
import mobileModule from './Square.mobile.module.css';
import useSelectedCssModule from '../hooks/useSelectedCssModule';
// Remove or comment out any PC CSS imports
import { logDomEvent } from '../utils/spaLogger';

// === Square.js: Portal-Based Rendering Version ===
function Square({ fileRank, color, highlight, handleSquareClick, showFileRank, invalidMoveSquare }) {
  const squareRef = useRef(null);
  // === Section: Select CSS Module for Device ===
  const styles = useSelectedCssModule(pcModule, mobileModule);
  // === End Section: Select CSS Module for Device ===
  // Use color prop directly (from static board map)
  const colorClass = color === 'cream' ? styles.light : styles.dark;
  // Accessibility: ARIA roles/labels and keyboard navigation
  const ariaLabel = `${fileRank} square`;
  // Show solved/unsolved indicator on the square if enabled
  // Chess file and rank extraction
  const file = fileRank[0];
  const rank = fileRank[1];
  // === Logger: Square Click Handler Wrapper ===
  const handleSquareClickWithLog = () => {
    if (squareRef.current) {
      const domNode = squareRef.current;
      const domHtml = domNode.outerHTML;
      const element = domNode.className || domNode.tagName;
      const parent = domNode.parentElement ? (domNode.parentElement.className || domNode.parentElement.tagName) : 'unknown';
      logDomEvent('Square', 'square-click', element, domHtml, domNode, parent);
    }
    handleSquareClick(fileRank);
  };
  // === End Logger: Square Click Handler Wrapper ===
  return (
    <div
      ref={squareRef}
      className={`${styles.square} ${colorClass}`}
      data-file-rank={fileRank}
      onClick={handleSquareClickWithLog}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleSquareClickWithLog();
        }
      }}
    >
      {/* File/rank label removed; now handled only in TileLayer.js */}
    </div>
  );
}

export default Square;
// === End Section: Square.js (Portal-Based Rendering) ===
